import posthog from 'posthog-js'
import useAppStore from '~/hooks/useAppStore'

export function track(event: string, properties?: Record<string, unknown>) {
  const { dataset, cosmosSite } = useAppStore.getState()
  posthog.capture(event, { dataset, region: cosmosSite, ...properties })
}

export function captureException(error: unknown, properties?: Record<string, unknown>) {
  posthog.captureException(error, properties)
}
